import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdowns, setActiveDropdowns] = useState(new Set());

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleDropdown = (dropdownId, event) => {
    event.preventDefault();
    event.stopPropagation();
    
    setActiveDropdowns(prev => {
      const newSet = new Set(prev);
      if (newSet.has(dropdownId)) {
        newSet.delete(dropdownId);
      } else {
        newSet.add(dropdownId);
      }
      return newSet;
    });
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setActiveDropdowns(new Set()); // Close all dropdowns when mobile menu closes
  };


  return (
    <header id="header" className={`header d-flex align-items-center sticky-top ${isScrolled ? 'scrolled' : ''} ${isMobileMenuOpen ? 'mobile-nav-active' : ''}`}>
      <div className="container position-relative d-flex align-items-center justify-content-between">
        
        <Link to="/" className="logo d-flex align-items-center me-auto me-xl-0">
          <img src="/assets/img/dtk_logo.png" alt="DTK College" style={{ height: '80px !important', width: 'auto', maxHeight: '80px' }} />
        </Link>

        <nav id="navmenu" className="navmenu">
          <ul>
            <li className="dropdown dropdown-flex" style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <Link to="/about-us" style={{flex: 1}}><span>About Us</span></Link>
              <i className="bi bi-chevron-down toggle-dropdown" onClick={(e) => toggleDropdown('about-us', e)} style={{marginLeft: '5px', cursor: 'pointer', padding: '5px'}}></i>
              <ul className={activeDropdowns.has('about-us') ? 'dropdown-active' : ''}>
                <li><Link to="/principals-welcome">Principal's Welcome</Link></li>
                {/* <li><Link to="/international-student">International Student</Link></li> */}
              </ul>
            </li>
            <li className="dropdown"><a href="#apprenticeships" onClick={(e) => toggleDropdown('apprenticeships', e)}><span>Apprenticeships</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
              <ul className={activeDropdowns.has('apprenticeships') ? 'dropdown-active' : ''}>
                <li><Link to="/apprenticeships-intro">Apprenticeships Intro</Link></li>
                <li><Link to="/lead-adult-care-worker-level-3">Lead Adult Care Worker Level 3</Link></li>
                <li><Link to="/leader-adult-care-level-5">Leader in Adult Care Level 5</Link></li>
                <li><Link to="/lead-practitioner-adult-care-level-4">Lead Practitioner in Adult Care Level 4</Link></li>
                <li><Link to="/hair-professional-level-2">Hair Professional Apprenticeship Level 2</Link></li>
                <li><Link to="/creative-hair-professional-level-3">Creative Hair Professional Apprenticeship Level 3</Link></li>
                <li><Link to="/commis-chef-level-2">Commis Chef Apprenticeship Level 2</Link></li>
                <li><Link to="/production-chef-level-2">Production chef Apprenticeship Level 2</Link></li>
              </ul>
            </li>
            <li className="dropdown dropdown-flex" style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <Link to="/courses" style={{flex: 1}}><span>Courses</span></Link>
              <i className="bi bi-chevron-down toggle-dropdown" onClick={(e) => toggleDropdown('courses', e)} style={{marginLeft: '5px', cursor: 'pointer', padding: '5px'}}></i>
              <ul className={activeDropdowns.has('courses') ? 'dropdown-active' : ''}>
                <li><Link to="/course-fees">Course Fees</Link></li>
                <li><Link to="/edsq">Essential Digital Skills Qualification (EDSQ)</Link></li>
                <li><Link to="/bcs-itq">BCS Level 2 Certificate in IT User Skills (ITQ)</Link></li>
                <li className="dropdown"><a href="#functional-skills" onClick={(e) => toggleDropdown('functional-skills', e)}><span>Functional Skills</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                  <ul className={activeDropdowns.has('functional-skills') ? 'dropdown-active' : ''}>
                    <li><Link to="/maths-functional-entry">Maths Functional Skills Entry 1,2,3</Link></li>
                    <li><Link to="/english-functional-entry">English Functional Skills Entry 1,2,3</Link></li>
                    <li><Link to="/functional-english-level-2">Functional Skills English Level 2</Link></li>
                    <li><Link to="/functional-maths-level-2">Functional Skills Maths Level 2</Link></li>
                  </ul>
                </li>
              </ul>
            </li>
            <li className="dropdown"><a href="#policies-procedures" onClick={(e) => toggleDropdown('policies-procedures', e)}><span>Policies and Procedures</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
              <ul className={activeDropdowns.has('policies-procedures') ? 'dropdown-active' : ''}>
                <li><Link to="/data-protection">Data Protection Policy</Link></li>
                <li><Link to="/complaint">Complaint Policy</Link></li>
                <li><Link to="/equality-diversity">Equality and Diversity Policy</Link></li>
                <li><Link to="/assessment-appeals">Assessment Appeals Policy</Link></li>
                <li><Link to="/health-safety">Health and Safety Policy</Link></li>
                <li><Link to="/conflict-interest">Conflict Of Interest Policy</Link></li>
                <li><Link to="/college-iag">College IAG Policy</Link></li>
                <li><Link to="/malpractice-plagiarism">Malpractice Plagiarism Policy</Link></li>
                <li><Link to="/safer-recruitment">Safer Recruitment Policy</Link></li>
                <li><Link to="/sustainability">Sustainability Policy</Link></li>
                <li><Link to="/modern-slavery">College Modern Slavery Policy</Link></li>
                <li className="dropdown"><a href="#safeguarding-prevent" onClick={(e) => toggleDropdown('safeguarding-prevent', e)}><span>Safeguarding And Prevent Policy</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                  <ul className={activeDropdowns.has('safeguarding-prevent') ? 'dropdown-active' : ''}>
                    <li><Link to="/safeguarding">Safeguarding Policy</Link></li>
                    <li><Link to="/prevent">Prevent Policy</Link></li>
                  </ul>
                </li>
                <li><Link to="/whistleblowing">Whistleblowing Policy</Link></li>
              </ul>
            </li>
            <li><Link to="/calendar">Calendar</Link></li>
            {/* <li className="dropdown"><a href="#apply-online" onClick={(e) => toggleDropdown('apply-online', e)}><span>Apply Online</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
              <ul className={activeDropdowns.has('apply-online') ? 'dropdown-active' : ''}>
                <li><Link to="/ukeu-students">UKEU Students</Link></li>
              </ul>
            </li> */}
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </nav>

        <i 
          className={`mobile-nav-toggle d-xl-none bi ${isMobileMenuOpen ? 'bi-x' : 'bi-list'}`}
          onClick={() => isMobileMenuOpen ? closeMobileMenu() : setIsMobileMenuOpen(true)}
        ></i>

      </div>
    </header>
  );
}

export default Header;
